import React from "react";
import CgmQrReferenceImg from "src/assets/images/cgm/connection-journey/cgm-qr-reference.png";

const QrStep: React.FC = () => {
  return (
    <div className="px-4 py-4 flex flex-col items-center gap-4 w-full">
      <h1 className="text-2xl font-semibold text-black">
        Connect to your Sensor
      </h1>
      <p className="text-sm text-gray-500 text-center">
        Scan the QR on the back of the sensor to connect with the GoodFlip app
      </p>
      <img
        src={CgmQrReferenceImg}
        alt="CGM QR Reference"
        className="w-full h-auto mt-6"
      />
    </div>
  );
};

export default QrStep;
